import React, {useEffect, useState} from 'react';
import food_p1 from './img/food-3.webp';
import chadaeva_p from './img/chadaeva.jpeg';
import food_example_p1 from './img/food_1.jpg';
import food_example_p2 from './img/food_2.jpg';
import {
    Box,
    Container, IconButton,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    Link,
    Typography
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import {useStore} from "./store";
import CafeCalendar from "./CafeCalendar";
import CafePrice from "./CafePrice";


const Cookshop = () => {
    const { settings,  } = useStore();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Container>
            {isMobile && (
                <>
                    <Typography variant={'h6'} gutterBottom>
                        Питанию мы уделяем особое внимание, так как оно должно быть организовано с учетом особенностей организма учеников: быстрого роста, повышенных умственных нагрузок, активности.
                    </Typography>
                    <img className="rounded-1" src={food_p1} alt="Завтрак и обед"
                         loading="lazy"
                         style={{
                             width: '100%',
                             height: 'auto',
                             borderRadius: '12px',
                             objectFit: 'cover',
                         }}
                    />
                    <Typography variant="subtitle1" fontWeight="bold" align={'center'} mt={2}>
                        Пример завтрака и обеда
                    </Typography>
                </>
            )}

            <Box mt={2} mb={2}>
                {!isMobile && (
                    <ImageList cols={2} gap={8}>
                        <ImageListItem>
                            <img
                                srcSet={`${chadaeva_p}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                src={`${chadaeva_p}?w=164&h=164&fit=crop&auto=format`}
                                alt="Чадаева"
                                loading="lazy"/>
                        </ImageListItem>
                        <ImageListItem>
                            <Typography variant={'h6'} gutterBottom ml={3}>
                                Мы разработали и постоянно улучшаем питание для детей школьников.
                                Мы поддерживаем национальный проект Демография, созданный Роспотребнадзором с целью улучшить состояние здоровья школьников. В рамках данного проекта мы и составляли меню.
                            </Typography>
                            <Typography variant={'h6'} gutterBottom ml={3}>
                                Во всех наших блюдах присутствует достаточное количество как макро, так и микронутриентов, так необходимых для здоровья растущего организма.
                            </Typography>
                            <Typography variant={'h6'} gutterBottom ml={3}>
                                Иногда дефициты витаминов и микроэлементов не заметны на первый взгляд, и не всегда их можно выявить с помощью анализов, но если долгое время ребёнок не будет получать какой-то элемент, то есть вероятность, что в организме, особенно у детей школьного возраста (ведь нагрузка на организм огромная) может произойти сбой.
                                Поэтому мы и составляем рацион питания детей таким образом, что в нем присутствует достаточное количество клетчатки, выпечка из муки высшего сорта.
                            </Typography>
                        </ImageListItem>
                    </ImageList>
                )}
                <Typography variant={'h6'} gutterBottom>
                    Мы даем детям достаточное количество белков/жиров/углеводов. Еда, которой мы кормим детей, дает им энергию, а не забирает. Мы тщательно выбираем продукты для наших блюд, не используем полуфабрикатов, консервантов, усилителей вкуса и прочих вредных добавок.
                    Во всех наших блюдах мы соблюдаем минимальное количество добавленной соли и сахара, которые при переизбытке приводят в некоторых случаях, к необратимым последствиям.
                    Для нас здоровье детей одна из ключевых ценностей, и мы делаем все возможное, чтобы как можно больше полезных веществ было в нашем меню.
                </Typography>
            </Box>

            {!isMobile && (
                <Box>
                    <ImageList>
                        <ImageListItem>
                            <img
                                srcSet={food_example_p1}
                                src={food_example_p1}
                                alt={'Пример завтрака'}
                                loading="lazy"/>
                            <ImageListItemBar
                                title={'Пример завтрака'}
                                subtitle={''}
                                actionIcon={
                                    <IconButton
                                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                        aria-label={`info about`}
                                    >
                                        <InfoIcon />
                                    </IconButton>
                                }
                            />
                        </ImageListItem>
                        <ImageListItem>
                            <img
                                srcSet={food_example_p2}
                                src={food_example_p2}
                                alt={'Пример обеда'}
                                loading="lazy"
                            />
                            <ImageListItemBar
                                title={`Пример обеда`}
                                subtitle={''}
                                actionIcon={
                                    <IconButton
                                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                        aria-label={`info about`}
                                    >
                                        <InfoIcon />
                                    </IconButton>
                                }
                            />
                        </ImageListItem>
                    </ImageList>

                </Box>
            )}
            <Typography variant={'h6'} gutterBottom>Еду для детей мы готовим в пароконвектоматах, без обжарки и добавления лишнего масла.
                Накормить ребенка сытно и вкусно вообще не проблема!
                Дети питаются в собственной школьной столовой, рассчитанной на 80 посадочных мест.
                В школе питание привозное. Школу обслуживает ИП Чадаева Наталья Николаевна (214020, Смоленская обл., г. Смоленск, ул. Шевченко, д.65.
                <Link href="mailto:chadaeva.natali@mail.ru"> chadaeva.natali@mail.ru</Link>).
                Еда готовится непосредственно перед подачей и доставляется в школу в термоконтейнерах.
                Поставщик питания тщательно контролирует качество продуктов.
                Учащиеся получают ежедневное полноценное горячее питание по выбранной категории.
            </Typography>
            <CafePrice/>
            <CafeCalendar/>
            <Typography variant={'h6'}>
                Лицо, ответственное за организацию питания — директор школы, Наталья Александровна Иванова,
                телефон <Link href={`tel:${settings.phone}`}> {settings.phone}</Link>, электронная почта
                <Link href={`mailto:${settings.email}`}> {settings.email}</Link>
            </Typography>

        </Container>
    );
};

export default Cookshop;